import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../CommonLoader";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Breadcrumbs, Checkbox, Typography } from "@mui/material";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";


const EmailsettingNotification = () => {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  const [cardData, setCardData] = useState([]);
  const rows = cardData ?? [];
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [faqData, setfaqData] = useState("2");
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);

  const [TotalPageLoadTime, SetTotalPageLoadTime] = useState(0);
  const [PageLoadTime, SetPageLoadTime] = useState(0);
  const [SampleSpeed, SetSampleSpeed] = useState(0);

  const [Url, Seturl] = useState("");
  const [UserExperienceSettingsErr, SetUserExperienceSettingsErr] =
    useState("");
  const [UpdateId, SetUpdateId] = useState("");
  const [Apdex, SetApdex] = useState("");
  const [loading, Setloading] = useState(false);

  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const navigate = useNavigate();
  const [totalpageerror, SetTotalpageerror] = useState()
  const [pageloaderror, SetPageloaderror] = useState()
  const [seederror, SetSeederror] = useState()
  const [uxscoreerror, SetUxscoreerror] = useState()
  const [userExpSettingPlan, setuserExpSettingPlan] = useState({ status: true, error: "" });
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [domainNameUrl, setDomainNameUrl] = useState({ domain_name: '', domain_url: '' });
  const [notificationSettings, setNotificationSettings] = useState({
    sslMail: false,
    manualReport: false,
    weeklyReport: false,
    noKeywordRank: false,
    noCompetitorRank: false,
    noCompetitorAnalysis: false,
  });



  const [notificationErrors, setNotificationErrors] = useState({});

  const GetUserExperienceSettings = async () => {
    Setloading(true);
    SetTotalPageLoadTime(1);
    SetPageLoadTime(1);
    SetSampleSpeed(1);
    Seturl("");
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}settings/UxScoreSettings/?user_domain_id=${esodata.domaindata.value.header_selected}`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/errorpages");
          }
        });
      Setloading(false);

      if (datavalue?.data) {
        SetTotalPageLoadTime(datavalue.data[0].tol_page_load_time);
        SetPageLoadTime(datavalue.data[0].page_load_time);
        SetSampleSpeed(datavalue.data[0].sample_seed);
        Seturl(datavalue.data[0].default_url);
        SetApdex(datavalue.data[0].apdex_score_metrics);
        SetUpdateId(datavalue.data[0].id);
      }
    } catch (err) {
      Setloading(false);
      console.log(err);
    }
  };
  const apihandleClose = () => {
    setapiOpen(false);
  };
  const SaveSettings = async () => {
    Setloading(true);
    try {
      const response = await axios
        .post(
          `${process.env.REACT_APP_API_URL}settings/email_settings_view/`,
          {
            ssl_mail: notificationSettings?.sslMail,
            manual_report: notificationSettings?.manualReport,
            weekly_report: notificationSettings?.weeklyReport,
            no_keywords_rank: notificationSettings?.noKeywordRank,
            no_competitor_rank: notificationSettings?.noCompetitorRank,
            no_competitor_analyse: notificationSettings?.noCompetitorAnalysis,
          },

          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/errorpages");
          }
        });
      setapiOpen(true);
      setapierrorMsg(response?.data?.message);
      Setloading(false);
    } catch (err) {
      Setloading(false);
    }

  };
  const emailnotification = async () => {
    try {
      const datavalue = await axios
        .get(
          `${process.env.REACT_APP_API_URL}settings/email_settings_view/`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        )
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/errorpages");
          }
        });
      Setloading(false);

      if (datavalue?.data) {
        setNotificationSettings(apiToStateKeyMap(datavalue?.data));
      }
    } catch (err) {
      Setloading(false);
      console.log(err);
    }
  }
  useEffect(() => {
    emailnotification();
    const checkUserPlan = async () => {
      const userExpSettingP = await Utils("performance_settings", ApiToken);
      if (userExpSettingP.status) {
        GetUserExperienceSettings();
        faqdatafun();
      }
      setuserExpSettingPlan(userExpSettingP);
    };
    checkUserPlan();
    GetuserDatavalue();
  }, []);



  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }

      });
      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({ ...domainNameUrl, domain_name: datavalue?.data?.dor_domain_name, domain_url: datavalue?.data?.dor_domain_url });
      }
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {
    const checkUserPlan = async () => {
      const userExpSettingP = await Utils("performance_settings", ApiToken);
      if (userExpSettingP.status) {
        var DomainList = esodata.domainlist.value;
        DomainList = DomainList.find(
          (obj) => obj.id == esodata.domaindata.value.header_selected
        );
        if (DomainList) {
          Seturl(DomainList.domain__url);
        }
      }
      setuserExpSettingPlan(userExpSettingP);
    };
    checkUserPlan();
  }, [esodata]);

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=68`;

    try {
      const doaminsectiondatavalue = await axios
        .get(datavar, {
          headers: {
            Authorization: `${ApiToken}`,
          },
        })
        .catch((error) => {
          if (
            error?.response?.status == 599 ||
            error?.response?.status == 400 ||
            error?.response?.status == 500
          ) {
            setapiOpen(true);
            setapierrorMsg(error?.response?.data?.error);
          } else if (error?.code == "ERR_NETWORK") {
            navigate("/errorpages");
          }
        });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs);
      }
    } catch (err) { }
  };
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1);
    } else {
      setfaqData(2);
    }
    setToggle((pre) => !pre);
  };

  const handleCheckboxChange = (key) => (event) => {
    setNotificationSettings((prev) => ({
      ...prev,
      [key]: event.target.checked,
    }));
  };

  const apiToStateKeyMap = (apiData) => ({
    sslMail: apiData.ssl_mail || false,
    manualReport: apiData.manual_report || false,
    weeklyReport: apiData.weekly_report || false,
    noKeywordRank: apiData.no_keywords_rank || false,
    noCompetitorRank: apiData.no_competitor_rank || false,
    noCompetitorAnalysis: apiData.no_competitor_analyse || false,
  });


  const handleReset = () => {
    setNotificationSettings({
      sslMail: false,
      manualReport: false,
      weeklyReport: false,
      noKeywordRank: false,
      noCompetitorRank: false,
      noCompetitorAnalysis: false,
    });
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Email Notification Settings</title>
      </Helmet>
      <div className={`over_all_container user_experieceover_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {loading === true ? <Loader /> : null}

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Notification Settings
                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Settings' },
                        { title: 'Notification Settings', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid" style={{ padding: "40px 0", background: "#fff!important" }}>
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap">
                  {userExpSettingPlan.status ? (
                    <div className="user_experince_form_container_wrap">
                      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                        <div className="kannantest">
                          {[
                            { key: "sslMail", label: "SSL Mail" },
                            { key: "manualReport", label: "Manual Report" },
                            { key: "weeklyReport", label: "Weekly Report" },
                            { key: "noKeywordRank", label: "No Keywords Rank" },
                            { key: "noCompetitorRank", label: "No Competitor Ranking" },
                            { key: "noCompetitorAnalysis", label: "No Competitor Analysis" },
                          ]
                            .reduce((acc, curr, i) => {
                              if (i % 2 === 0) acc.push([curr]);
                              else acc[acc.length - 1].push(curr);
                              return acc;
                            }, [])
                            .map((row, idx) => (
                              <div key={idx} className="notifi-setting">
                                {row.map(({ key, label }) => (
                                  <div key={key} style={{ flex: 1, marginBottom: "10px" }}>
                                    <label
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "5px",
                                        fontSize: ".968rem",
                                        color: "#0b2033",
                                      }}
                                    >

                                      <Checkbox
                                        checked={notificationSettings[key]}
                                        onChange={handleCheckboxChange(key)}
                                        disabled={first.statusDomain}
                                        sx={{
                                          color: "#0b2033",
                                          '&.Mui-checked': {
                                            color: "#ff601f",
                                          }
                                        }}
                                      />

                                      {/* <input
                                        type="checkbox"
                                        name={key}
                                        checked={notificationSettings[key]}
                                        onChange={handleCheckboxChange(key)}
                                        disabled={first.statusDomain}
                                        style={{
                                          width: "17px",
                                          height: "17px",
                                          cursor: "pointer",
                                          accentColor: "#ff601f",
                                        }}
                                      /> */}
                                      {label}
                                    </label>
                                    <div
                                      style={{ color: "red", fontSize: "13px", marginTop: "4px" }}
                                    >
                                      {notificationErrors[key]}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))}
                        </div>
                        {/* Save and Reset Buttons */}
                        <div className="dialog_box_btn"
                          style={{
                            display: "flex",
                            gap: "20px",
                            justifyContent: "center",
                            marginTop: "20px",
                          }}
                        >
                          <button className="keyword-cancel"

                            onClick={first.statusDomain ? () => setcheckD(first.statusDomain) : SaveSettings}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <Freeaudit planStatus={userExpSettingPlan} />
                  )}
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <div className="">
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
        </div>

        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.elitesiteoptimizer.ai/" target="_blank"> <span className="footer-brand"> Elite site Optimizer</span></a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
        {!openCommonAlerts &&
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        }
      </div>
      <Dialog
        open={checkD}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="domain-verify-alert"
      >
        <DialogTitle className="keyword-dialog-header"><ReportProblemIcon fontSize="large" sx={{ color: '#ff601f' }} /></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', lineHeight: '1px', width: "max-content" }}>
              <p>{"Please verify your domain ("}<a href={domainNameUrl.domain_url} title={`go to this link ${domainNameUrl.domain_url}`} >{domainNameUrl.domain_name}</a>{") to access these features"}</p>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
          <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
        </DialogActions>
      </Dialog>
            <UserActivityTracker pagename="Settings - Notification Settings" />
    </>
  );
};

export default EmailsettingNotification;
